import { useLazyQuery } from '@apollo/client';
import React, { useState } from 'react';
import SelectTile from '../Product/components/SelectTile/SelectTile';
import ProductAnalyticsData from '../ProductCard/components/ProductAnalyticsData';
import SelectTileGroup from '../Product/components/SelectTileGroup/SelectTileGroup.styled';
import { handleAddToCart } from '../QuickAdd/QuickAdd';
import { PRODUCT_VARIANT_PIM_DATA } from '../QuickAdd/QuickAdd.gql';
import * as Styled from './QuickAddModal.styled';
import { useQuickAddModal } from './QuickAddModal.context';
/**
 * Modal that allows QuickAdd functionality on mobile
 */
var QuickAddModal = function () {
    var _a = useState(null), currentVariant = _a[0], setCurrentVariant = _a[1];
    var getProductVariantPimData = useLazyQuery(PRODUCT_VARIANT_PIM_DATA, {
        onCompleted: function (data) {
            var pimData = data.productVariants[0].components[0];
            handleAddToCart({ currentVariant: currentVariant, pimData: pimData });
        }
    })[0];
    var _b = useQuickAddModal(), handleClose = _b.handleClose, isOpen = _b.isOpen, quickAddModalProps = _b.quickAddModalProps;
    var _c = quickAddModalProps.title, title = _c === void 0 ? '' : _c, _d = quickAddModalProps.subtitle, subtitle = _d === void 0 ? '' : _d, _e = quickAddModalProps.image, image = _e === void 0 ? '' : _e, _f = quickAddModalProps.pdpLink, pdpLink = _f === void 0 ? '' : _f, _g = quickAddModalProps.currentColorSizes, currentColorSizes = _g === void 0 ? [] : _g, _h = quickAddModalProps.currentColorCategory, currentColorCategory = _h === void 0 ? [] : _h, _j = quickAddModalProps.itemCount, itemCount = _j === void 0 ? 0 : _j, _k = quickAddModalProps.shopifyId, shopifyId = _k === void 0 ? '' : _k, productCardPosition = quickAddModalProps.productCardPosition;
    return (React.createElement(Styled.Modal, { hasHeaderDivider: false, isPeeking: true, onRequestClose: handleClose, isOpen: isOpen, withCollapse: true },
        React.createElement(ProductAnalyticsData, { shopifyId: shopifyId, cardPosition: productCardPosition }),
        React.createElement(Styled.ProductVariant, { title: title, subtitle: subtitle, image: image, productVariantUrl: pdpLink, dataLabel: "productCard_title" }),
        React.createElement(SelectTileGroup, { tiles: currentColorSizes.length }, currentColorSizes === null || currentColorSizes === void 0 ? void 0 : currentColorSizes.map(function (currentColorSize) { return (
        // @ts-ignore-next-line
        React.createElement(SelectTile, { id: currentColorSize.variantId, value: currentColorSize.value, key: currentColorSize.id, disabled: !currentColorSize.available, isUnavailable: !currentColorSize.available, note: currentColorSize.guidance || '', isPack: itemCount > 1, packSize: itemCount, category: currentColorCategory, onClick: function () {
                setCurrentVariant({
                    id: currentColorSize.variantId,
                    category: currentColorCategory,
                    isPack: itemCount > 1,
                    packSize: itemCount,
                    pdpLink: pdpLink
                });
                handleClose();
                getProductVariantPimData({
                    variables: { ids: [currentColorSize.variantId] }
                });
            }, dataLabel: "productCard_quickAdd_L2" })); }))));
};
export default QuickAddModal;
